import { QueryKey } from '@tanstack/react-query';
import type { ShipmentListDTO } from '@uturn/api/v1';
import { queryClient } from '@uturn/portal/query';
import type { AxiosResponse } from 'axios';

type NextPrevShipments = {
	next?: ShipmentListDTO;
	prev?: ShipmentListDTO;
};

function getShipments(queryKey: QueryKey): ShipmentListDTO[] {
	if (queryKey[0]?.toString().includes('groups')) {
		const data = queryClient.getQueryData<{
			data: { shipments: AxiosResponse<ShipmentListDTO[]> };
		}>(queryKey);
		return data?.data.shipments.data ?? [];
	}

	const data = queryClient.getQueryData<{
		data: AxiosResponse<ShipmentListDTO[]>;
	}>(queryKey);
	return data?.data.data ?? [];
}

export function getNextPrevShipments({
	shipments,
	currentShipmentNumber,
}: {
	shipments?: ShipmentListDTO[];
	currentShipmentNumber: number;
}) {
	const result: NextPrevShipments = {
		next: undefined,
		prev: undefined,
	};

	if (!shipments || !shipments.length) {
		return result;
	}

	const index = shipments.findIndex(
		(shipment) => shipment.shipmentNumber === currentShipmentNumber,
	);

	if (index === -1) {
		return result;
	}

	if (index < shipments.length - 1) {
		result.next = shipments[index + 1];
	}

	if (index > 0) {
		result.prev = shipments[index - 1];
	}

	return result;
}

export function getShipmentsNavigation({
	queryKey,
	currentShipmentNumber,
}: {
	queryKey: QueryKey;
	currentShipmentNumber: number;
}) {
	const shipments = getShipments(queryKey);

	return getNextPrevShipments({
		shipments,
		currentShipmentNumber,
	});
}
